import React from 'react';
import { LoadingIndicator } from '../loading-indicator/loading-indicator';
import styles from './spinner.module.scss';
export const Spinner = ({ active }) => {
    return active ? (React.createElement("div", { "data-testid": "spinner", className: styles.spinnerWrap },
        React.createElement(LoadingIndicator, null))) : null;
};
